
import { apiClient } from '../utils/apiClient';

interface ProfileResponse {
  id: string;
  login: string;
  phone: string;
  name: string;
  favorite_symbols: string[];
  is_trading?: boolean;
  account?: {
    name: string;
    is_trading?: boolean;
  };
}

export const fetchProfileFromAPI = async (accessToken: string): Promise<ProfileResponse> => {
  // Use apiClient for automatic token refresh handling
  return apiClient.get<ProfileResponse>('profile');
};
